import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostResendInvitationRequest = {
	userId: number;
};

export const postResendInvitation = createPostEndpoint<PostResendInvitationRequest>(
	({ userId }) => `/api/v3/core/users/${userId}/links/invitation/send`
);
